import React from 'react'
import { useNetInfo } from '../contexts/NetInfoContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWifi, faExclamationTriangle, faServer } from '@fortawesome/pro-solid-svg-icons'
import { cn } from './shadcn/utils'

export const NetworkStatusBar: React.FC = () => {
  const { status } = useNetInfo()

  // Don't show bar if everything is working fine
  if (status.isOnline && status.isApiAvailable && status.lastRequestStatus !== 'failure') {
    return null
  }

  // Determine the message and icon
  let message: string
  let icon = faExclamationTriangle
  let severity: 'critical' | 'warning' = 'warning'

  if (!status.isOnline) {
    message = 'Není připojení k internetu.'
    icon = faWifi
    severity = 'critical'
  } else if (!status.isApiAvailable) {
    message = 'Služby Depoto jsou nedostupné.'
    icon = faServer
    severity = 'critical'
  } else if (status.lastRequestStatus === 'failure') {
    message = `Služby Depoto jsou nedostupné.`
    severity = 'warning'
  } else if (status.errorMessage) {
    message = status.errorMessage
  } else {
    return null
  }

  return (
    <div
      className={cn(
        'fixed bottom-0 left-0 right-0 z-50 flex items-center justify-center px-4 py-2 text-white transition-all duration-300',
        severity === 'critical' ? 'bg-red' : 'bg-red',
      )}>
      <div className="flex items-center gap-2 text-sm font-medium">
        <FontAwesomeIcon icon={icon} className="animate-pulse" />
        <span>{message}</span>
        {status.lastRequestTime && (
          <span className="text-xs opacity-75 ml-2">
            Poslední aktivita: {new Date(status.lastRequestTime).toLocaleTimeString()}
          </span>
        )}
      </div>
    </div>
  )
}
